import { render, staticRenderFns } from "./WBPadDialog.vue?vue&type=template&id=a55f103c&scoped=true"
import script from "./WBPadDialog.vue?vue&type=script&lang=js"
export * from "./WBPadDialog.vue?vue&type=script&lang=js"
import style0 from "./WBPadDialog.vue?vue&type=style&index=0&id=a55f103c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55f103c",
  null
  
)

export default component.exports